// /js/stripe/stripe.js
import { store } from "../store/store.js";
import { alertas, alert_error } from "../ui/alerts.js";
import { getSelectedPlan, ValidateEmail, convertirMXNaUSD } from "../utils/helpers.js";
import { register } from "../api/api.js";

// SOLO UNA VEZ:
const stripe = Stripe("pk_live_51S5ujzRa4OxhItokWtLNkIFYRy39Tt2GsK2DUic5c6IEf6QiKpDBcPNazp4nGTDwmOgi3WT8Qk7G2QEi7C1e6XZy008KaShSdY");


/*

MODO PRUEBA
const stripe = Stripe("pk_test_51S5ujzRa4OxhItokKc1tIDuOaqCyCsKpWfyESDVkLx5RsFRDj3FyiRNwSyB69FC3xPizONRMtw6C3JNApMY71FlD00oDpqtum3");

MODO REAL
const stripe = Stripe("pk_live_51S5ujzRa4OxhItokWtLNkIFYRy39Tt2GsK2DUic5c6IEf6QiKpDBcPNazp4nGTDwmOgi3WT8Qk7G2QEi7C1e6XZy008KaShSdY");




var url_prod = "payment_stripe";
var url_test = "payment_stripe_test";
var url_usd= "payment_stripe_usd";
var url_usd_test= "payment_stripe_test_usd";

*/
let elements;

export function start_sripe_payment(){




  store.SELECTED_PLAN  = null;
  store.SELECTED_PRICE = 0;

  const email  = document.getElementById("email")?.value || "";
  const nombre = document.getElementById("name")?.value || "";
  const pass1  = document.getElementById("password")?.value || "";
  const pass2  = document.getElementById("repeat_password")?.value || "";

  // validar términos
  const termsCheckbox = document.querySelector('input[type="checkbox"]');
  if (!termsCheckbox || !termsCheckbox.checked) {
    alertas({
      type: "error",
      title: "Terms required",
      message: "You must accept the Terms & Conditions and Privacy Policy."
    });
    return;
  }

  if(!ValidateEmail(email)){
    alertas({
      type: "error",
      title: "Error Email",
      message: "Invalid Format"
    });

    return;
  } else if(nombre === ""){
    alertas({
      type: "error",
      title: "Error Name",
      message: "Invalid Format"
    });
    return;
  } else if(pass1 === ""){
    alertas({
      type: "error",
      title: "Error",
      message: "Put Password 1"
    });
    return;
  } else if(pass2 === ""){
    alertas({
      type: "error",
      title: "Error",
      message: "Put Password 2"
    });
    return;
  } else if(pass1 !== pass2){
    alertas({
      type: "error",
      title: "Error",
      message: "Password_1 must be the same as Password_2"
    });
    return;
  }

  store.GLOBAL_EMAIL = email;
  store.GLOBAL_NAME = nombre;
  store.GLOBAL_PASSWROD = pass1;



register();

/*

  const selectedPlan = getSelectedPlan();

  if(!selectedPlan){
    alertas({
      type: "error",
      title: "Select a plan",
      message: "Please select a subscription plan."
    });
    return;
  }

  store.SELECTED_PLAN  = selectedPlan.plan;
  store.SELECTED_PRICE = selectedPlan.price;

  const email  = document.getElementById("email")?.value || "";
  const nombre = document.getElementById("name")?.value || "";
  const pass1  = document.getElementById("password")?.value || "";
  const pass2  = document.getElementById("repeat_password")?.value || "";

  // validar términos
  const termsCheckbox = document.querySelector('input[type="checkbox"]');
  if (!termsCheckbox || !termsCheckbox.checked) {
    alertas({
      type: "error",
      title: "Terms required",
      message: "You must accept the Terms & Conditions and Privacy Policy."
    });
    return;
  }

  if(!ValidateEmail(email)){
    alertas({
      type: "error",
      title: "Error Email",
      message: "Invalid Format"
    });

    return;
  } else if(nombre === ""){
    alertas({
      type: "error",
      title: "Error Name",
      message: "Invalid Format"
    });
    return;
  } else if(pass1 === ""){
    alertas({
      type: "error",
      title: "Error",
      message: "Put Password 1"
    });
    return;
  } else if(pass2 === ""){
    alertas({
      type: "error",
      title: "Error",
      message: "Put Password 2"
    });
    return;
  } else if(pass1 !== pass2){
    alertas({
      type: "error",
      title: "Error",
      message: "Password_1 must be the same as Password_2"
    });
    return;
  }

  store.GLOBAL_EMAIL = email;
  store.GLOBAL_NAME = nombre;
  store.GLOBAL_PASSWROD = pass1;

  const content_payment = document.getElementById("if_payment");
  if(!content_payment){
    console.error("#if_payment not found");
    return;
  }

  const stripeHtml =
    '<div style="margin-top:180px;background-color:#32bceb70;border-radius:10px;padding:20px;">' +
      '<h5 align="center" style="color:#ffffff;">Contribution MXN $' + store.SELECTED_PRICE +
      '<br><span style="font-size:15px; color:#167ac6;" id="usd_transform"></span></h5><br><br>' +

      '<form id="payment-form" style="width:100%;background-color:#f0f2f37a;padding:20px;border-radius:10px;overflow:hidden;">' +
        '<div id="link-authentication-element"></div>' +
        '<div id="payment-element"></div><br><br>' +

        '<button class="btn btn-success" style="width:50%; float:right;" id="submit" type="submit">' +
          '<div class="spinner hidden" id="spinner"></div>' +
          '<span id="button-text">Pay now</span>' +
        '</button>' +

        '<div id="payment-message"></div>' +
      '</form>' +
    '</div>';

  content_payment.innerHTML = stripeHtml;

  convertirMXNaUSD("usd_transform", store.SELECTED_PRICE);

  // Stripe init
  initializeStripe();
*/



}






async function initializeStripe() {

  const form = document.querySelector("#payment-form");
  if (!form) {
    console.error("payment-form not found");
    return;
  }
  form.addEventListener("submit", handleSubmit);

  // equivalente a tu url_ = "payment_stripe_test"
  const url_ = "payment_stripe";

  const payload = {
    amount: store.SELECTED_PRICE,
    user_email: store.GLOBAL_EMAIL,
    nombre: store.GLOBAL_NAME,
    plan: "pago_cliente_normal",
    referencia_venta: store.refStorage ?? ""
  };

  const resp = await fetch(
    `${store.URL_PHP}Stripe/${url_}/?amount=${store.SELECTED_PRICE}00&id_reserve=${encodeURIComponent(store.GLOBAL_EMAIL)}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }
  ).then(r => r.json());

  const clientSecret = resp?.clientSecret;
  if(!clientSecret){
    console.error("No clientSecret:", resp);
    alert_error("Stripe error: no client secret");
    return;
  }

  elements = stripe.elements({ clientSecret });

  elements.create("linkAuthentication").mount("#link-authentication-element");
  elements.create("payment", { layout:"tabs" }).mount("#payment-element");
}








async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);

  try {
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: { return_url: store.URL_PHP },
      redirect: "if_required",
    });

    if (error) {
      alert_error(error.message);
      setLoading(false);
      return;
    }

    if (paymentIntent?.status === "requires_action") {
      // OXXO/SPEI ok
      setLoading(false);
      return;
    }

    if (paymentIntent?.status === "succeeded") {
      register(); // igual que tu flujo original
      return;
    }

    console.log("Estado:", paymentIntent?.status);
  } catch (err) {
    alert_error(err?.message || "Error al procesar el pago");
  }

  setLoading(false);
}

function setLoading(isLoading) {
  const submit = document.querySelector("#submit");
  const spinner = document.querySelector("#spinner");
  const text = document.querySelector("#button-text");

  if (!submit || !spinner || !text) return;

  if (isLoading) {
    submit.disabled = true;
    spinner.classList.remove("hidden");
    text.classList.add("hidden");
  } else {
    submit.disabled = false;
    spinner.classList.add("hidden");
    text.classList.remove("hidden");
  }
}








export function getStripeConfig({
  mode = "test",     // "test" | "prod"
  currency = "mxn"   // "mxn" | "usd"
} = {}) {

  const STRIPE_KEYS = {
    test: "pk_test_51S5ujzRa4OxhItokKc1tIDuOaqCyCsKpWfyESDVkLx5RsFRDj3FyiRNwSyB69FC3xPizONRMtw6C3JNApMY71FlD00oDpqtum3",
    prod: "pk_live_51S5ujzRa4OxhItokWtLNkIFYRy39Tt2GsK2DUic5c6IEf6QiKpDBcPNazp4nGTDwmOgi3WT8Qk7G2QEi7C1e6XZy008KaShSdY"
  };

  const URLS = {
    mxn: {
      test: "payment_stripe_test",
      prod: "payment_stripe"
    },
    usd: {
      test: "payment_stripe_test_usd",
      prod: "payment_stripe_usd"
    }
  };

  if (!STRIPE_KEYS[mode]) {
    throw new Error(`Modo inválido: ${mode}`);
  }

  if (!URLS[currency]) {
    throw new Error(`Moneda inválida: ${currency}`);
  }

  return {
    stripe: Stripe(STRIPE_KEYS[mode]),
    publishableKey: STRIPE_KEYS[mode],
    url: URLS[currency][mode],
    mode,
    currency
  };
}